import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import withPillNavigation from '../../shared/withPillNavigation.decorator';
import SearchBar from '../../shared/searchBar/searchBar.component';
import AgGrid from '../../shared/agGrid/agGrid.component';
import { defaultColumnDefs, journalsColumnDefs, localJournalsColumnDefs } from '../../shared/columnDefinitions/batchProvisionsPage';
import { journalsPropTypes, localJournalsPropTypes } from '../../shared/propTypes';

import {
  setJournalsFilter,
  unsetJournalsFilter,
  setLocalJournalsFilter,
  unsetLocalJournalsFilter,
} from './store/actions';

const JournalPillTypes = {
  JOURNAL: 'JOURNAL',
  LOCAL_JOURNAL: 'LOCAL_JOURNAL',
};

const JournalPillDefinitions = [
  { label: 'Journals', type: JournalPillTypes.JOURNAL },
  { label: 'Local Journals', type: JournalPillTypes.LOCAL_JOURNAL },
];

class BatchProvisionJournals extends PureComponent {
  static propTypes = {
    activePill: PropTypes.oneOf(Object.values(JournalPillTypes)).isRequired,
    journals: journalsPropTypes,
    journalsFilter: PropTypes.string,
    localJournals: localJournalsPropTypes,
    localJournalsFilter: PropTypes.string,

    setJournalsFilter: PropTypes.func.isRequired,
    unsetJournalsFilter: PropTypes.func.isRequired,
    setLocalJournalsFilter: PropTypes.func.isRequired,
    unsetLocalJournalsFilter: PropTypes.func.isRequired,
  };

  render() {
    const {
      activePill,
      journals,
      journalsFilter,
      localJournals,
      localJournalsFilter,

      setJournalsFilter,
      unsetJournalsFilter,
      setLocalJournalsFilter,
      unsetLocalJournalsFilter,
    } = this.props;

    return (
      <div className="batch-provisions-journals">
        <div className="row">
          <div className="col-5 ml-auto">
            {activePill === JournalPillTypes.JOURNAL
              ? <SearchBar
                onCancel={unsetJournalsFilter}
                onSearch={setJournalsFilter}
                value={journalsFilter}
              /> : <SearchBar
                onCancel={unsetLocalJournalsFilter}
                onSearch={setLocalJournalsFilter}
                value={localJournalsFilter}
              />}
          </div>
        </div>

        {activePill === JournalPillTypes.JOURNAL
          ? (
            <div className="batch-provisions-grid">
              <AgGrid
                columnDefs={journalsColumnDefs}
                defaultColDef={defaultColumnDefs}
                rowData={journals}
                quickFilterText={journalsFilter}
              />
            </div>
          ) : (
            <div className="batch-provisions-grid">
              <AgGrid
                columnDefs={localJournalsColumnDefs}
                defaultColDef={defaultColumnDefs}
                rowData={localJournals}
                quickFilterText={localJournalsFilter}
              />
            </div>
          )
        }
      </div>
    );
  }
}

export default connect(state => {
  const {
    batchProvisionsWithStatus,
    journalsFilter,
    localJournalsFilter,
  } = state.provision.batchProvisions;

  const {
    journals,
    localJournals,
  } = batchProvisionsWithStatus;

  return {
    journals,
    journalsFilter,
    localJournals,
    localJournalsFilter,
  };
}, {
  setJournalsFilter,
  unsetJournalsFilter,
  setLocalJournalsFilter,
  unsetLocalJournalsFilter,
})(withPillNavigation(
  () => JournalPillDefinitions.filter(definition => definition.type !== JournalPillTypes.LOCAL_JOURNAL),
  { propTypes: {} }
)(BatchProvisionJournals)
);
